import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "wcag-gif-container1" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "wcag-gif-container"
  }, [
    _createElementVNode("img", {
      src: _ctx.still,
      alt: _ctx.alt,
      loading: "lazy"
    }, null, 8, _hoisted_2),
    (!(_ctx.stayPaused || _ctx.stillOnly))
      ? (_openBlock(), _createElementBlock("details", _hoisted_3, [
          _createElementVNode("summary", {
            role: "button",
            "aria-label": "static image",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
          }, [
            _createVNode(_component_v_icon, { color: "black" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pause ? 'mdi-play' : 'mdi-pause'), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.gif,
              alt: 'Animated: ' + _ctx.alt,
              loading: "lazy"
            }, null, 8, _hoisted_5)
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("cite", { style: {"display":"none"} }, [
      _createTextVNode(" Adapted from "),
      _createElementVNode("a", { href: "https://css-tricks.com/pause-gif-details-summary/" }, "CSS Tricks"),
      _createTextVNode(" and "),
      _createElementVNode("a", { href: "https://codepen.io/chriscoyier/pen/pogQJER" }, "CodePen")
    ], -1))
  ], 8, _hoisted_1))
}